import React, { forwardRef, useId, useImperativeHandle, useState } from "react";
import SnEditor from "@shared/components/SnEditor";
import { global } from "@shared/libs/Global";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getReply } from "@shared/utils/IssueUtils";
import { showDialog } from "@widgets/CommonDialog";
import { sendIssueSnapshotTelegramByParams } from "../issueTelegram";

interface popupProps {
  formData: any;
  modalRef?: any;
  replyList?: replyProps[];
  files?: any[];
}

interface replyProps {
  formData?: string;
  txt_body?: string;
  tm_reg?: string;
  cd_user_reg?: string;
}

/**
 * Reply 팝업
 */
const SN_SFA_ISSUE_REG_005_POP_002 = forwardRef(
  (
    { formData, modalRef, replyList, files }: popupProps,
    ref: React.Ref<any>
  ) => {
    const { userInfo } = global();
    const uniqueId = useId();

    const [body, setBody] = useState("");

    useImperativeHandle(ref, () => ({
      onSave,
    }));

    const onSave = async () => {
      const params = {
        id: "sn_sfa_issue_reg_005_01",
        params: { cd_firm: userInfo.cd_firm, no_issue: formData.no_issue },
      };
      const data: any = await fnGetDataSet(params);
      formData = data[0][0];
      files = data[3];

      const updateData: any = {
        cd_firm: userInfo.cd_firm,
        no_issue: formData.no_issue,
        tm_amd: formData.tm_amd,
        cd_user_amd: userInfo.cd_user,
        nm_user_amd: userInfo.nm_user,
      };

      if (!body || body === "") {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const js_reply = getReply(formData, replyList || [], body);
      if (js_reply) updateData.js_reply = js_reply;

      const saveData = {
        sfa_issue: {
          update: [updateData],
        },
      };

      try {
        await fnSave("SN_SFA_ISSUE_REP_005_btnNewIssue", saveData);
        await sendMessage(updateData);
        return true;
      } catch (err) {
        return false;
      }
    };

    const sendMessage = async (data: any) => {
      const snapshotData = {
        ...(formData || {}),
        ...(data || {}),
        js_reply: (data && data.js_reply) || formData?.js_reply || [],
        js_attach: files || formData?.js_attach || [],
        js_txt_body:
          formData?.js_txt_body ||
          (formData?.txt_body ? [{ txt_body: formData.txt_body }] : []),
      };
      const params = {
        ...formData,
        ...data,
        cd_firm: userInfo.cd_firm,
        cd_menu: "SN_SFA_ISSUE_REG_005",
        no_issue: (data && data.no_issue) || formData?.no_issue,
        msg_flag: "reply",
        origin: `${window.location.origin}/snotes`,
        send_telegram: true,
        snapshot_data: snapshotData,
      };
      // 2026-03-09: const result = callApi("telegram/sendMsg", params);
      await sendIssueSnapshotTelegramByParams(params);
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          marginTop: 10,
          overflow: "hidden",
        }}
      >
        <div
          className="no-tailwind"
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            border: "1px solid rgb(186,191,199)",
            borderRadius: 4,
          }}
        >
          {formData?.no_issue && (
            <SnEditor
              uniqueId={uniqueId}
              selectedData={formData.no_issue}
              body={body}
              setBody={setBody}
            />
          )}
        </div>
      </div>
    );
  }
);

export default SN_SFA_ISSUE_REG_005_POP_002;
